import { render, staticRenderFns } from "./ClientButton.vue?vue&type=template&id=5e90a53c"
import script from "./ClientButton.vue?vue&type=script&lang=js"
export * from "./ClientButton.vue?vue&type=script&lang=js"
import style0 from "./ClientButton.vue?vue&type=style&index=0&id=5e90a53c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports